export default __webpack_public_path__ + "970bff9968e7ac3e76e396587b41835d.svg";